import register from '@kpsys/angularjs-register';
import FondsDataService from './fonds.data-service';
import fondsRoutes from './fonds.routes';

/**
 * @ngdoc module
 * @name fondsDataService
 * @module use-cases.fonds
 *
 * @requires Restangular
 *
 * @description
 * Data service for providing the newest documents
 */
export default register('uc.fonds')
    .service(FondsDataService.serviceName, FondsDataService)
    .config(fondsRoutes)
    .name();
